module.exports = __webpack_public_path__ + "img/huwelijksdrukwerk-drukwerk-annonce-trouwen-hannah-kyle-preeg-emboss-origami-2.73720e0e.jpg";